import { Component } from '@angular/core';

@Component({
  selector: 'app-glossary-page-skeleton-loader',
  templateUrl: './glossary-page-skeleton-loader.component.html',
  standalone: false,
})
export class GlossaryPageSkeletonLoaderComponent {}
